export default __webpack_public_path__ + "static/media/linkedin.fb8bdc3e.svg";